export default {
	message: {
		title: '消息中心',
		look_msg: '查看消息',
		is_read: '是否已读',
		read: '已读',
		unread: '未读',
		msg_tilte: '消息标题',
		send_at: '发送时间',
		msg_type: '消息类型',
		sys_msg: '系统消息',
		ord_msg: '普通消息',
	},
}
